import { GENDERS } from '../../Insurance.constants';

import { DEFAULT_VALUES, FULL_NAME_SEQUENCE, NAMES } from './FullNameInputs.constants';

export const findGenderId = ({ gender }) => {
  const { id } =
    GENDERS.find(({ sysName }) => {
      const fromList = sysName.toUpperCase();
      const fromParam = gender.toUpperCase();

      return fromList === fromParam;
    }) ?? {};

  return id;
};

export const generateFullName = ({ parts }) => {
  return FULL_NAME_SEQUENCE.map((key) => {
    return parts[key];
  }).join(' ');
};

export const generateFullNameParts = ({ value }) => {
  const result = { ...DEFAULT_VALUES };

  if (!value) {
    return result;
  }

  const [lastname, firstname, patronymic] = value.split(' ');

  return {
    ...result,
    [NAMES.FIRSTNAME]: firstname ?? '',
    [NAMES.LASTNAME]: lastname ?? '',
    [NAMES.PATRONYMIC]: patronymic ?? '',
  };
};
